import { createContext } from 'react';
import axios from 'axios';
//* Axios instance provider PART *//
const AxiosContext = createContext(axios.create({
    baseURL: 'https://admin.recolte.pl',
    timeout: 1000
}))

export default AxiosContext;